import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const StyledViewMore = styled.span`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  ${mediaqueries.greaterThan('desktop')`
    margin-left: auto;
  `};
`;

const StyledPlus = styled(Icon)`
  height: ${rem('10px')};
  margin-right: ${rem('6px')};
  width: ${rem('10px')};
`;

export { StyledViewMore, StyledPlus };
